import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface SortingByIndicators {
  name: string,
  icon: string,
  slug: string,
  active: boolean
}

export interface ViewHeaderFilters {
  viewUuid?: string | null;
  byLastDays?: number | null;
  byIndicator?: string | null;
}

const DEFAULT_CATEGORY_SLUG = 'teamSuccessteamScore';
const DEFAULT_LAST_DAYS = 30;

@Component({
  selector: 'app-to-page-header',
  templateUrl: './to-page-header.component.html',
  styleUrls: ['./to-page-header.component.scss']
})

export class ToPageHeaderComponent implements OnInit {
  @Output() setDaysForSwitch = new EventEmitter<number>();
  @Output() setIndicatorForSort = new EventEmitter<string>();
  @Input() set viewFilters(value: ViewHeaderFilters | null) {
    this.applyFiltersFromView(value);
  }

  sortingByIndicators: SortingByIndicators[] = [
    {name: this.translate.instant('team_score'), icon: '',slug: 'teamSuccessteamScore', active: true},
    {name: this.translate.instant('team_performance'), icon: 'performance',slug: 'performance', active: false},
    {name: this.translate.instant('team_satisfaction'), icon: 'satisfaction',slug: 'satisfaction', active: false},
    {name: this.translate.instant('team_motivation'), icon: 'motivation',slug: 'motivation', active: false},
    {name: this.translate.instant('team_stress_free'), icon: 'stress',slug: 'stress', active: false},
  ];

  is30DaysSorting: boolean = true;
  is90DaysSorting: boolean = false;
  private activeViewUuid: string | null = null;
  private activeIndicatorSlug = DEFAULT_CATEGORY_SLUG;
  private activeLastDays = DEFAULT_LAST_DAYS;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  sortByDays(days: number) {
    if (this.activeLastDays === days) {
      return;
    }
    this.setDaysSelection(days);
    this.setDaysForSwitch.emit(days);
  }

  sortByCategory(categoryIndex: number) {
    if (categoryIndex < 0) {
      return;
    }
    const selected = this.sortingByIndicators[categoryIndex];
    if (!selected || selected.slug === this.activeIndicatorSlug) {
      return;
    }
    this.setIndicatorSelection(selected.slug);
    this.setIndicatorForSort.emit(selected.slug);
  }

  private applyFiltersFromView(value: ViewHeaderFilters | null) {
    const nextUuid = value?.viewUuid || null;
    const nextDays = value?.byLastDays === 90 ? 90 : DEFAULT_LAST_DAYS;
    const nextSlug = this.normalizeIndicatorSlug(value?.byIndicator);

    const viewChanged = this.activeViewUuid !== nextUuid;
    this.activeViewUuid = nextUuid;

    if (viewChanged || this.activeLastDays !== nextDays) {
      this.setDaysSelection(nextDays);
    }
    if (viewChanged || this.activeIndicatorSlug !== nextSlug) {
      this.setIndicatorSelection(nextSlug);
    }
  }

  private setDaysSelection(days: number) {
    this.activeLastDays = days;
    this.is30DaysSorting = days === 30;
    this.is90DaysSorting = days === 90;
  }

  private setIndicatorSelection(slug: string) {
    this.activeIndicatorSlug = slug;
    this.sortingByIndicators.forEach((indicator: SortingByIndicators) => {
      indicator.active = indicator.slug === slug;
    });
  }

  private normalizeIndicatorSlug(value?: string | null): string {
    if (!value) {
      return DEFAULT_CATEGORY_SLUG;
    }
    const lower = String(value).toLowerCase();
    if (lower.includes('successteam') || lower === 'score' || lower === 'teamsuccessteamscore') {
      return 'teamSuccessteamScore';
    }
    const known = this.sortingByIndicators.find((indicator: SortingByIndicators) =>
      indicator.slug.toLowerCase() === lower || lower.includes(indicator.slug.toLowerCase())
    );
    return known?.slug || DEFAULT_CATEGORY_SLUG;
  }
}
